import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { SecurityType } from '@pinnakl/securities/domain';
import { withDevtools } from '@pinnakl/shared/signal-store';
import { getErrorMessage } from '@pinnakl/shared/util-helpers';
import { PinnaklUIToastMessage } from '@pinnakl/shared/util-providers';
import { SecurityTypesApiService } from './security-types-api.service';

interface SecurityTypesState {
  securityTypes: SecurityType[];
  loading: boolean;
  loaded: boolean;
}

const initialState: SecurityTypesState = {
  securityTypes: [],
  loading: false,
  loaded: false,
};

export const SecurityTypesStore = signalStore(
  { providedIn: 'root' },
  withDevtools('securityTypes'),
  withState(initialState),
  withMethods((store, api = inject(SecurityTypesApiService), toast = inject(PinnaklUIToastMessage)) => ({
    async loadSecurityTypes(forceRefetch = false): Promise<void> {
      if (!forceRefetch && (store.loaded() || store.loading())) return;
      patchState(store, { loading: true });
      try {
        const securityTypes = await api.getSecurityTypes();
        patchState(store, { securityTypes, loading: false, loaded: true });
      } catch (error) {
        toast.error(getErrorMessage('Something went wrong during security types fetch', error));
        patchState(store, { loading: false });
      }
    },
  })),
);
